"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_system_1 = require("styled-system");
var css_1 = require("@emotion/css");
var Box_1 = __importStar(require("./Box"));
var Icon_1 = __importDefault(require("./Icon"));
var Label_1 = __importDefault(require("./Label"));
var Spinner_1 = __importDefault(require("./Spinner"));
var useLoadingOnClickWrapper_1 = __importDefault(require("./utils/useLoadingOnClickWrapper"));
var Container = (0, Box_1.createBasicComponent)(function (props) { return ({
    // remove button styles
    background: 'none',
    border: 'none',
    fontSize: props.theme.fontSizes[2],
    fontFamily: props.theme.fonts.Roboto,
    cursor: 'pointer',
    width: props.fullWidth ? '100% !important' : 'fit-content',
    '&:disabled': {
        cursor: 'not-allowed',
    },
}); }, (0, styled_system_1.variant)({
    scale: 'buttons'
}));
Container.defaultProps = { as: 'button' };
Container.displayName = 'Container';
function Button(props) {
    var loading = props.loading, children = props.children, disabled = props.disabled, onClick = props.onClick, iconName = props.iconName, iconProps = props.iconProps, loadOnClick = props.loadOnClick, className = props.className, rest = __rest(props, ["loading", "children", "disabled", "onClick", "iconName", "iconProps", "loadOnClick", "className"]);
    var _a = (0, useLoadingOnClickWrapper_1.default)({ loading: loading, loadOnClick: loadOnClick, onClick: onClick }), loadingState = _a.loadingState, handleOnClick = _a.handleOnClick;
    var useSpacer = loadingState || iconName;
    return (react_1.default.createElement(Container
    // default type as button, so it won't submit a form
    , __assign({ 
        // default type as button, so it won't submit a form
        type: "button" }, rest, { className: (0, css_1.cx)('ff-ui-button', className), onClick: handleOnClick, disabled: loadingState ? true : disabled }),
        react_1.default.createElement(Label_1.default.L3
        // class name for css selector
        , { 
            // class name for css selector
            className: 'ff-ui-button-label', display: "flex", alignItems: "center", justifyContent: "center" },
            !loadingState && iconName && react_1.default.createElement(Icon_1.default, __assign({ className: 'ff-ui-button-icon', name: iconName, display: "block", fontSize: "20px" }, iconProps)),
            loadingState && react_1.default.createElement(Spinner_1.default, { size: "20px" }),
            useSpacer && react_1.default.createElement(Box_1.default, { width: "12px" }),
            children)));
}
exports.default = Button;
